
(function () {

  if (window.__saFormValidate) return;
  window.__saFormValidate = true;

  var forms = document.querySelectorAll('form');
  Array.prototype.forEach.call(forms, function (form) {
    var fields = form.querySelectorAll('[data-validate]');
    if (!fields.length) return;
    form.noValidate = true;

    function digits(v) { return (v.match(/\d/g) || []).length; }

    function isEmpty(el, v) {
      if (el.dataset.validate === 'phone' && el.dataset.prefix) {
        return digits(v) <= digits(el.dataset.prefix);
      }
      return v === '';
    }

    function isValid(el, v) {
      switch (el.dataset.validate) {
        case 'email': return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
        case 'phone': return digits(v) >= 8;
        case 'pass':  return v.length >= 6 && /^[0-9a-zA-Z]+$/.test(v);
        default:      return v.length >= 2;   
      }
    }

    function node(el) {
      var box = el.parentElement;
      return box ? box.querySelector('[data-err]') : null;
    }

    function show(el, text) {
      var n = node(el);
      if (n) { n.textContent = text || ''; n.hidden = !text; }
      el.setAttribute('aria-invalid', text ? 'true' : 'false');
    }

    var submitBtn = form.hasAttribute('data-keep-submit')
      ? null
      : form.querySelector('[type=submit]');

    function formReady() {
      for (var i = 0; i < fields.length; i += 1) {
        var el = fields[i];
        var v = String(el.value || '').trim();
        if (isEmpty(el, v) || !isValid(el, v)) return false;
      }

      var boxes = form.querySelectorAll('input[type=checkbox][required]');
      for (var k = 0; k < boxes.length; k += 1) if (!boxes[k].checked) return false;
      return true;
    }

    function refreshSubmit() {
      if (!submitBtn) return;
      submitBtn.disabled = !formReady();
    }

    form.addEventListener('input', refreshSubmit);
    form.addEventListener('change', refreshSubmit);
    refreshSubmit();

    Array.prototype.forEach.call(fields, function (el) {
      el.addEventListener('invalid', function (e) { e.preventDefault(); });

      el.addEventListener('input', function () { show(el, ''); });
    });

    form.addEventListener('submit', function (e) {
      var bad = null;
      Array.prototype.forEach.call(fields, function (el) {
        var v = String(el.value || '').trim();
        var text = '';
        if (isEmpty(el, v)) text = el.dataset.errortext || '';
        else if (!isValid(el, v)) text = el.dataset.errortext2 || el.dataset.errortext || '';
        show(el, text);
        if (text && !bad) bad = el;
      });
      if (bad) { e.preventDefault(); bad.focus(); }
    });
  });
})();
